import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileText = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.3332 1.3328H4.0004C3.64681 1.3328 3.30771 1.47329 3.05769 1.72336C2.80766 1.97343 2.6672 2.31259 2.6672 2.66624V13.3338C2.6672 13.6874 2.80766 14.0266 3.05769 14.2766C3.30771 14.5267 3.64681 14.6672 4.0004 14.6672H11.9996C12.3532 14.6672 12.6923 14.5267 12.9423 14.2766C13.1923 14.0266 13.3328 13.6874 13.3328 13.3338V5.33312M9.3332 1.3328C9.54421 1.33246 9.75321 1.37387 9.94816 1.45466C10.1431 1.53544 10.3201 1.654 10.4691 1.80351L12.8608 4.1957C13.0107 4.34471 13.1296 4.52195 13.2106 4.71718C13.2916 4.91241 13.3331 5.12175 13.3328 5.33312M9.3332 1.3328V4.6664C9.3332 4.84322 9.40343 5.01281 9.52844 5.13784C9.65345 5.26288 9.823 5.33312 9.9998 5.33312L13.3328 5.33312M6.6668 5.99984H5.3336M10.6664 8.66672H5.3336M10.6664 11.3336H5.3336",
		stroke: "currentColor",
		strokeWidth: 1.4,
		strokeLinecap: "round"
	})]
});
const ForwardRef = forwardRef(SvgFileText);
export default ForwardRef;
